import { z } from 'zod';

/**
 * Espelha `abrirChamadoSchema` do backend. As mensagens são as que o usuário
 * lê, então elas ficam aqui em português e em primeira pessoa — o 422 do
 * servidor é a rede de segurança, não a validação primária.
 */
export const abrirChamadoSchema = z.object({
  titulo: z
    .string()
    .trim()
    .min(5, 'Resuma o problema em uma frase')
    .max(160, 'Máximo de 160 caracteres'),
  descricao: z
    .string()
    .trim()
    .min(10, 'Conte o que aconteceu — o que você fez e o que apareceu na tela')
    .max(4000, 'Máximo de 4000 caracteres'),
  // Validação só de tamanho, como no backend: o campo é para alguém LIGAR. Uma
  // regex de telefone brasileiro rejeitaria ramal e observação ("após as 14h"),
  // e o custo do falso negativo é a pessoa não conseguir pedir ajuda.
  telefoneContato: z
    .string()
    .trim()
    .min(10, 'Informe o telefone com DDD')
    .max(20, 'Máximo de 20 caracteres'),
  urgencia: z.enum(['BAIXA', 'MEDIA', 'ALTA', 'CRITICA']),
});

export type FormularioDeChamado = z.infer<typeof abrirChamadoSchema>;

export const definirPrevisaoSchema = z.object({
  // `datetime-local` devolve `2026-09-18T18:00` (sem fuso, sem segundos) — a
  // conversão para ISO com fuso acontece no submit, não aqui.
  previsaoConclusaoEm: z.string().trim().min(1, 'Escolha a data e a hora'),
  observacao: z.string().trim().max(500, 'Máximo de 500 caracteres').optional(),
});

export type FormularioDePrevisao = z.infer<typeof definirPrevisaoSchema>;

export const agendarCorrecaoSchema = z.object({
  /** `<input type="date">` já devolve `AAAA-MM-DD`, que é o formato da API. */
  correcaoPrevistaEm: z.string().trim().min(1, 'Escolha a data'),
  descricao: z.string().trim().max(500, 'Máximo de 500 caracteres').optional(),
});

export type FormularioDeCorrecao = z.infer<typeof agendarCorrecaoSchema>;

export const concluirChamadoSchema = z.object({
  resolucao: z
    .string()
    .trim()
    .min(10, 'Descreva o que foi feito — é isto que o solicitante vai ler')
    .max(4000, 'Máximo de 4000 caracteres'),
});

export type FormularioDeConclusao = z.infer<typeof concluirChamadoSchema>;

export const transferirChamadoSchema = z.object({
  atendenteId: z.string().min(1, 'Escolha para quem transferir'),
  motivo: z.string().trim().max(500, 'Máximo de 500 caracteres').optional(),
});

export type FormularioDeTransferencia = z.infer<typeof transferirChamadoSchema>;
